export default __webpack_public_path__ + "static/media/direction.9423b037.png";